export default {
  en: {
    title: "Cases",
    subtitle: "Work that takes days and needs people, such as a dispute or a claim. Agents add tasks and requests to a case; only people work and decide them.",
    back: "Back to cases",
    col: { case: "Case", ref: "Reference", status: "Status", priority: "Priority", classification: "Classification", opened: "Opened", sla: "Time left", task: "Task", queue: "Queue" },
    showClosed: "Show closed",
    priority: { urgent: "Urgent", high: "High", normal: "Normal", low: "Low" },
    tab: { timeline: "Timeline", tasks: "Tasks ({{n}})", parties: "Parties", documents: "Documents", outcome: "Outcome" },
    event: { case_created: "Case opened", run_linked: "Agent run linked", document_added: "Document added", run_event: "Run update", task_created: "Task created", task_claimed: "Task claimed", task_decided: "Decision recorded", party_added: "Party added", note_added: "Note added", note: "Note", case_updated: "Case updated", task_escalated: "Task escalated", task_sla_breached: "SLA breached" },
    partyRole: { customer: "Customer", supplier: "Supplier", employee: "Employee", applicant: "Applicant", beneficiary: "Beneficiary", counterparty: "Counterparty", authority: "Authority", other: "Other" },
    field: { national_id: "National ID", employee_no: "Employee number", vendor_no: "Vendor number", email: "Email", phone: "Phone", department: "Department", city: "City" },
    noParties: "No parties",
    noOutcome: "No outcome yet",
    pii: { masked: "Personal data is masked. The pii-reader role is required to see it.", visible: "You can see personal data. Access is audited." },
    party: { name: "Name" },
    noDocuments: "No documents",
    status: { open: "Open", pending: "Pending", escalated: "Escalated", resolved: "Resolved", closed: "Closed" },
    form: {
      newCase: "New case",
      editCase: "Edit case",
      create: "Create",
      save: "Save",
      add: "Add",
      cancel: "Cancel",
      title: "Title",
      langAr: "Arabic",
      langEn: "English",
      type: "Case type",
      typeHelp: "Lowercase slug, e.g. invoice-dispute",
      assignee: "Assignee",
      owner: "Owner",
      slaHours: "Respond within (working hours)",
      hoursUnit: "hours",
      addParty: "Add party",
      partyRole: "Party role",
      refKey: "Identifier type",
      refValue: "Identifier",
      pii: "Natural person (name and identifiers are personal data)",
      created: "Case created",
      saved: "Case updated",
      partyAdded: "Party added",
      note: "Add a note",
      addNote: "Add note",
      noteAdded: "Note added",
      reopenSupervisor: "Reopening a closed case requires case-supervisor.",
    },
    issues: {
      type_invalid: "Case type must be a lowercase slug (letters, digits, '_', '.', ':' or '-').",
      type_required: "Choose the kind of case.",
      title_required: "Enter a title in Arabic or English.",
      text_too_long: "Text is limited to 2000 characters.",
      queue_invalid: "Queue must be a role name (letters, digits, '_', '.', ':', '/' or '-').",
      sla_invalid: "SLA must be between 0 and 8760 business hours.",
      external_ref_too_long: "Reference is limited to 256 characters.",
      party_role_invalid: "Choose a party role.",
      party_name_required: "Enter the party's name in Arabic or English.",
    },
    classification: { public: "Public", internal: "Internal", confidential: "Confidential", restricted: "Restricted" },
    producedBy: "Produced by {{who}}",
    feedback: {
      title: "Feedback on this outcome",
      accept: "Accept",
      reject: "Reject",
      correct: "Correct",
      correction: "Correct outcome",
      comment: "Comment",
      submit: "Submit feedback",
      saved: "Feedback recorded",
      given: { accept: "Accepted — thank you", reject: "Rejected — thank you", correct: "Correction recorded — thank you" },
      note: "Feedback is pseudonymised and exported for evaluation datasets; personal data is redacted.",
    },
  },
  ar: {
    title: "الحالات",
    subtitle: "عمل يستغرق أيامًا ويحتاج إلى أشخاص، مثل نزاع أو مطالبة. يضيف الوكلاء المهام والطلبات إلى الحالة؛ أما العمل عليها واتخاذ القرار فللأشخاص فقط.",
    back: "العودة إلى الحالات",
    col: { case: "الحالة", ref: "المرجع", status: "الوضع", priority: "الأولوية", classification: "التصنيف", opened: "تاريخ الفتح", sla: "الوقت المتبقي", task: "المهمة", queue: "القائمة" },
    showClosed: "عرض المغلقة",
    priority: { urgent: "عاجلة", high: "عالية", normal: "عادية", low: "منخفضة" },
    tab: { timeline: "الخط الزمني", tasks: "المهام ({{n}})", parties: "الأطراف", documents: "المستندات", outcome: "النتيجة" },
    event: { case_created: "فُتحت الحالة", run_linked: "رُبط تشغيل وكيل", document_added: "أُضيف مستند", run_event: "تحديث التشغيل", task_created: "أُنشئت مهمة", task_claimed: "أُسندت المهمة", task_decided: "سُجل القرار", party_added: "أُضيف طرف", note_added: "أُضيفت ملاحظة", note: "ملاحظة", case_updated: "حُدثت الحالة", task_escalated: "صُعّدت المهمة", task_sla_breached: "تجاوز مستوى الخدمة" },
    partyRole: { customer: "عميل", supplier: "مورد", employee: "موظف", applicant: "متقدم", beneficiary: "مستفيد", counterparty: "طرف مقابل", authority: "جهة رسمية", other: "أخرى" },
    field: { national_id: "رقم الهوية", employee_no: "الرقم الوظيفي", vendor_no: "رقم المورد", email: "البريد الإلكتروني", phone: "الهاتف", department: "الإدارة", city: "المدينة" },
    noParties: "لا توجد أطراف",
    noOutcome: "لا توجد نتيجة بعد",
    pii: { masked: "البيانات الشخصية مخفية. يلزم دور قارئ البيانات الشخصية لعرضها.", visible: "يمكنك رؤية البيانات الشخصية. الوصول مُدقق." },
    party: { name: "الاسم" },
    noDocuments: "لا توجد مستندات",
    status: { open: "مفتوحة", pending: "معلّقة", escalated: "مصعّدة", resolved: "محلولة", closed: "مغلقة" },
    form: {
      newCase: "حالة جديدة",
      editCase: "تعديل الحالة",
      create: "إنشاء",
      save: "حفظ",
      add: "إضافة",
      cancel: "إلغاء",
      title: "العنوان",
      langAr: "العربية",
      langEn: "الإنجليزية",
      type: "نوع الحالة",
      typeHelp: "معرّف بأحرف لاتينية صغيرة، مثل invoice-dispute",
      assignee: "المكلَّف",
      owner: "المالك",
      slaHours: "الرد خلال (ساعات العمل)",
      hoursUnit: "ساعة",
      addParty: "إضافة طرف",
      partyRole: "دور الطرف",
      refKey: "نوع المعرّف",
      refValue: "المعرّف",
      pii: "شخص طبيعي (الاسم والمعرّفات بيانات شخصية)",
      created: "تم إنشاء الحالة",
      saved: "تم تحديث الحالة",
      partyAdded: "تمت إضافة الطرف",
      note: "أضف ملاحظة",
      addNote: "إضافة ملاحظة",
      noteAdded: "تمت إضافة الملاحظة",
      reopenSupervisor: "إعادة فتح حالة مغلقة تتطلب دور مشرف الحالات.",
    },
    issues: {
      type_invalid: "يجب أن يكون نوع الحالة معرّفًا بأحرف لاتينية صغيرة (أحرف وأرقام و'_' أو '.' أو ':' أو '-').",
      type_required: "اختر نوع الحالة.",
      title_required: "أدخل عنوانًا بالعربية أو الإنجليزية.",
      text_too_long: "النص محدود بـ 2000 حرف.",
      queue_invalid: "يجب أن تكون القائمة اسم دور (أحرف وأرقام و'_' أو '.' أو ':' أو '/' أو '-').",
      sla_invalid: "يجب أن يكون مستوى الخدمة بين 0 و8760 ساعة عمل.",
      external_ref_too_long: "المرجع محدود بـ 256 حرفًا.",
      party_role_invalid: "اختر دور الطرف.",
      party_name_required: "أدخل اسم الطرف بالعربية أو الإنجليزية.",
    },
    classification: { public: "عام", internal: "داخلي", confidential: "سري", restricted: "مقيد" },
    producedBy: "أنتجها {{who}}",
    feedback: {
      title: "ملاحظات على هذه النتيجة",
      accept: "قبول",
      reject: "رفض",
      correct: "تصحيح",
      correction: "النتيجة الصحيحة",
      comment: "تعليق",
      submit: "إرسال الملاحظات",
      saved: "تم تسجيل الملاحظات",
      given: { accept: "قُبلت — شكرًا لك", reject: "رُفضت — شكرًا لك", correct: "سُجل التصحيح — شكرًا لك" },
      note: "تُعمّى الملاحظات وتُصدَّر لمجموعات بيانات التقييم مع حجب البيانات الشخصية.",
    },
  },
};
